import React, { Component, createRef } from 'react';
import KhePrivateChatReportListTable from './components/KhePrivateChatReportListTable';
import { khePrivateChatReportStore } from './stores/KhePrivateChatReportStore';
import { userDetailStores } from '../UserManagement/stores/UserDetailStores';
import UserDetailModal from '../UserManagement/components/UserDetail/UserDetailModal';
import KhePrivateChatReportFeedbackModal from './components/KhePrivateChatReportFeedbackModal';

class KhePrivateChatReportList extends Component {
    constructor(props) {
        super(props);
        this.khePrivateChatReportFeedbackModalRef = createRef();
    };

    onShowUserInfo = (userId) => {
        if (!userId) return;
        userDetailStores.setUserIdForLoadDetail(userId);
        userDetailStores.onChangeUserDetailModal(true);
    }

    onFeedbackIconPress = (userIdToSend) => {
        if (this.khePrivateChatReportFeedbackModalRef.current) {
            this.khePrivateChatReportFeedbackModalRef.current.settUserIdToSendFeedback(userIdToSend);
        }
    }

    render() {
        return (
            <div className="card">
                <div className="card-body">
                    <KhePrivateChatReportListTable
                        onFeedbackIconPress={this.onFeedbackIconPress}
                        onShowUserInfo={this.onShowUserInfo}
                    />
                </div>
                <UserDetailModal />
                <KhePrivateChatReportFeedbackModal
                    ref={this.khePrivateChatReportFeedbackModalRef} />
            </div>
        );
    }

    componentDidMount = async () => {
        khePrivateChatReportStore.getData();
    };

}

export default KhePrivateChatReportList;